import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { starterPackService } from '@/services/starter';

export function useStarterPackList() {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({
        request: starterPackService.list
    });

    const actions = {
        enable: crudAction.confirmAndEnable({
            request: starterPackService.enable,
            onSuccess: () => fetchList()
        }),
        disable: crudAction.confirmAndDisable({
            request: starterPackService.disable,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: starterPackService.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
